import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const pomtableApi = api
  .enhanceEndpoints({ addTagTypes: ['POMTable'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOMTables: builder.query<po_mtable[], any>({
        query: ({ cid, olid }) => `pomtable/${cid}/${olid}`,
        providesTags: ['POMTable'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (data.type === 'POS_ORDER_UPDATED') {
                dispatch(pomtableApi.util.invalidateTags(['POMTable']));
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getPOMTableById: builder.query<po_mtable, string>({
        query: id => `pomtable/byid/${id}`,
        providesTags: ['POMTable']
      }),
      insertPOMTable: builder.mutation({
        query: pomtable => ({
          url: `pomtable/`,
          method: 'POST',
          body: pomtable
        }),
        invalidatesTags: ['POMTable']
      }),
      updatePOMTable: builder.mutation({
        query: pomtable => ({
          url: `pomtable/`,
          method: 'PUT',
          body: pomtable
        }),
        invalidatesTags: ['POMTable']
      }),
      deletePOMTable: builder.mutation({
        query: pomtable => ({
          url: `pomtable/${pomtable.tb_id}`,
          method: 'DELETE',
          body: pomtable
        }),
        invalidatesTags: ['POMTable']
      })
    }),
    overrideExisting: true
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOMTablesQuery,
  useGetPOMTableByIdQuery,
  useInsertPOMTableMutation,
  useUpdatePOMTableMutation,
  useDeletePOMTableMutation
} = pomtableApi;

